module.exports = "/packs/images/pages/gift_cards/gift-card-giftcard~3ab5056ee64ba5cf28bca29a78c30b68.png";